import {UserPropertiesDetails} from "components/src/api/admin/generated";
import {SideBar} from "components/src/sidebar/SideBar";
import {TFunction} from "i18next";

const buildSettingsMenuItem = (userPropertiesDetails : UserPropertiesDetails, nodeContainer: React.ReactNode[], path : string[],t: TFunction<string, undefined> ,additionalPaths : string[]) : React.ReactNode[] =>
{
    path.push(userPropertiesDetails.category)

    if (userPropertiesDetails.children.length > 0)
    {
        // recursively get all child nodes and flatten two levels otherwise the ReactNode structure is invalid
        const childNodes = userPropertiesDetails.children.map((child) =>
            buildSettingsMenuItem(child, [], [...path], t, additionalPaths)).flat(2);

        if (childNodes.length > 0)
        {
            nodeContainer.push(
                <SideBar.Dropdown key={userPropertiesDetails.category} title={t(userPropertiesDetails.displayNameKey)}>
                    {childNodes}
                </SideBar.Dropdown>
            )
        }
    }
    else {
        nodeContainer.push(
            <SideBar.Item key={userPropertiesDetails.category}
                          title={t(userPropertiesDetails.displayNameKey)}
                          link={[...path, additionalPaths].filter(s => s.length > 0).join("/")}/>
        )
    }

    return nodeContainer;
}

const buildSettingsMenu = (details : UserPropertiesDetails[], basePath : string, t: TFunction<string, undefined>, additionalPaths : string[] = []): React.ReactNode[] =>
{
    return details.map((property : UserPropertiesDetails) =>
    {
        if (property.properties.length == 0 && property.children.length == 0) {
            return;
        }

        return buildSettingsMenuItem(property, [], [basePath], t, additionalPaths)
    });
}

export const SettingsMenuBuilder = () => {
    return
}

SettingsMenuBuilder.buildMenu = buildSettingsMenu;
